/**
 * Created by Jan on 03.09.2017.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Forms = Lfl.Forms || {};

    (function (Forms, $, undefined) {
        /**
         * @memberOf Lfl.Forms
         */
        Lfl.Forms.Inputs = Forms.Inputs || {};

        (function (Inputs, $, undefined) {
            if (Lfl.Files.isLoadedAlready(Lfl.Forms.Inputs, 'MdeInitializer')) {
                return;
            }


            /*
             |==========================================================================================================
             | Class definition
             |==========================================================================================================
             */

            /**
             * Helps with correctly initializing the Markdown Editor plugin.
             * @param {object} parameters
             * @param {element} parameters.element The text area element.
             * @param {string} [parameters.additionalPreviewText] Any additional text which should be added to the
             * preview button title tooltip.
             * @param {object} parameters.resetText Parameters regarding the resetting or reloading of text.
             * @param {string} parameters.resetText.resetTextConfirmationModalPath CSS path to the modal which asks the
             * user for confirmation that they really want to reset the text to original.
             * @param {string} parameters.resetText.confirmResetTextButtonPath CSS path to the button which confirms
             * that text should be reset.
             * @param {string} parameters.resetText.resetTextButtonText The text of the toolbar button used to reset or
             * reload.
             * @param {string} parameters.storeEditorEnabledUrl The URL where the disable/enable graphical editor user
             * setting should be sent to be stored.
             *
             * @memberOf Lfl.Forms.Inputs
             * @lends Lfl.Forms.Inputs.MarkdownEditor
             * @constructor
             */
            Lfl.Forms.Inputs.MarkdownEditor = function (parameters) {
                /*
                 |------------------------------------------------------------------------------------------------------
                 | Construction
                 |------------------------------------------------------------------------------------------------------
                 */

                // Note: This actually stands for "markdown editor", not "myself".
                var me = this;
                var easyMDE;
                var cm;
                var cmKeyMap;
                var originalEscKeymap;
                var originalText;

                function init() {
                    // TODO KG-II Add event hook to update form field
                    //      See: AjaxSubmissionOfJavascriptTextareaEditors::Kindergarten
                    if (typeof EasyMDE === 'undefined') {
                        throw new Error("The EasyMDE plugin is not loaded. Please include it.");
                    }

                    easyMDE = new EasyMDE({
                        element: parameters.element,
                        status: false,
                        toolbar: createToolbar(),
                        spellChecker: false
                    });

                    fixToolbarButtonPlacement();

                    cm = easyMDE.codemirror;
                    cmKeyMap = cm.getOption("extraKeys");
                    originalEscKeymap = cm.getOption("extraKeys").Esc;
                    /**
                     * The "real" version of the text, not the autosaved version the user might
                     * see.
                     * @type {string}
                     */
                    originalText = parameters.element.textContent;
                }

                /*
                 |------------------------------------------------------------------------------------------------------
                 | Public methods
                 |------------------------------------------------------------------------------------------------------
                 */

                this.resetTextToOriginal = function () {
                    clearAutosavedValue();
                    setText(originalText);
                };

                this.clearText = function () {
                    clearAutosavedValue();
                    setText('');
                };

                /*
                 |-------------------------------------------------------------------------
                 | Enable and disable */

                this.enable = function () {
                    if (false === this.isEnabled()) {
                        init();
                    } else {
                        console.warn("Attempting to enable the markdown editor when it is already enabled. Ignoring.");
                    }

                    storeEditorEnabledSetting(true);
                };

                /**
                 * Notifies the newly initialized editor that the user has enabled it's usage.  
                 */
                this.notifyNewEditorAboutEnable = function () {
                    storeEditorEnabledSetting(true);
                };

                this.disable = function () {
                    easyMDE.toTextArea();
                    easyMDE = null;

                    storeEditorEnabledSetting(false);
                };

                this.isEnabled = function () {
                    return typeof easyMDE !== 'undefined' && easyMDE !== null;
                };

                /*
                 |------------------------------------------------------------------------------------------------------
                 | Private methods
                 |------------------------------------------------------------------------------------------------------
                 */

                function createToolbar() {
                    return [
                        {
                            name: "bold",
                            action: EasyMDE.toggleBold,
                            className: "fa fa-bold",
                            title: "Tučné"
                        },
                        {
                            name: "italic",
                            action: EasyMDE.toggleItalic,
                            className: "fa fa-italic",
                            title: "Kurzíva"
                        },
                        {
                            name: "strikethrough",
                            action: EasyMDE.toggleStrikethrough,
                            className: "fa fa-strikethrough",
                            title: "Přeškrtnuté"
                        },
                        "|",
                        {
                            name: "heading-1",
                            action: EasyMDE.toggleHeading1,
                            className: "fa fa-header",
                            title: "Nadpis"
                        },
                        "|",
                        {
                            name: "unordered-list",
                            action: EasyMDE.toggleUnorderedList,
                            className: "fa fa-list-ul",
                            title: "Seznam"
                        },
                        {
                            name: "ordered-list",
                            action: EasyMDE.toggleOrderedList,
                            className: "fa fa-list-ol",
                            title: "Číslovaný seznam"
                        },
                        "|",
                        {
                            name: "link",
                            action: EasyMDE.drawLink,
                            className: "fa fa-link",
                            title: "Vložit odkaz"
                        },
                        "|",
                        {
                            name: "preview",
                            action: EasyMDE.togglePreview,
                            className: "fa fa-eye",
                            title: "Náhled" + ( typeof parameters.additionalPreviewText === 'undefined' ? ""
                                : " — " + parameters.additionalPreviewText),
                            noDisable: true
                        },
                        {
                            name: "side-by-side",
                            action: function (editor) {
                                var previousState = editor.isFullscreenActive();
                                editor.toggleSideBySide();

                                function check() {
                                    var currentState = editor.isFullscreenActive();

                                    if (previousState !== currentState) {
                                        // Handle the toggle via menu button I
                                        handleFullscreenChange();
                                    }

                                    previousState = currentState;
                                }

                                setTimeout(check, 0);
                                // For slower computers, the 0 delay may be too fast, so make another check later.
                                setTimeout(check, 200);
                            },
                            className: "fa fa-columns",
                            title: "Zobrazení \"vedle sebe\"",
                            noDisable: true,
                            noMobile: true
                        },
                        {
                            name: "fullscreen",
                            action: function (editor) {
                                editor.toggleFullScreen();
                                // Handle the toggle via menu button II
                                handleFullscreenChange();
                            },
                            className: "fa fa-arrows-alt",
                            title: "Celá obrazovka",
                            noDisable: true,
                            noMobile: true
                        },
                        {
                            name: "reset-text",
                            action: function (editor) {

                                // TODO MOBA II - copied from modal-button - consider extracting a helper, or using a
                                //      button directly.
                                // It is safer to select the modal after the button is clicked because of scenarios when
                                // the button is added to the page dynamically (via AJAX).
                                // The impact on performance is negligible while errors are prevented.
                                var $modal = $(parameters.resetText.resetTextConfirmationModalPath);

                                // For similar reasons we need to register the callback only after the modal is ready.
                                registerConfirmResetTextButtonCallback();

                                Lfl.Modals.Displayer.displayBootstrapModal($modal);
                            },
                            // See: FixBrokenSimpleMde::ButtonClassFix
                            className: "fa fa-refresh lfl-textarea-editor-pull-right",
                            title: parameters.resetText.resetTextButtonText,
                            noDisable: true,
                        },
                    ]
                }

                /**
                 * Fixes the position of special LYFLE buttons on the toolbar.
                 *
                 * See: FixBrokenSimpleMde::ButtonClassFix
                 */
                function fixToolbarButtonPlacement() {
                    $('.lfl-textarea-editor-pull-right').closest('button').addClass('pull-right');
                }

                /*
                 |----------------------------------------------------------------------------------------
                 | Text resetting
                 |----------------
                 | Clearing the autosaved text. */


                function registerConfirmResetTextButtonCallback() {
                    $(parameters.resetText.confirmResetTextButtonPath).click(function () {
                        me.resetTextToOriginal();
                    });
                }

                function clearAutosavedValue() {
                    easyMDE.clearAutosavedValue();
                }

                function setText(text) {
                    cm.setValue(text);
                }

                /*
                 |----------------------------------------------------------------------------------------
                 | Fullscreen toggling
                 |---------------------
                 | And the corresponding hiding of the menu:
                 | When EasyMDE goes fullscreen, it relies on z-index to be above everything else on the page. But
                 | sadly, since the parent of the textarea is below the top and left navigation (z-index-vise), we have
                 | to hide the menu.
                 | And since no event is fired when the fullscreen is toggled and the EasyMDE did practically
                 | everything in it's power to prevent a detection of such an event (including the usage of several
                 | years old CodeMirror, which does not contain the optionChanged event), we have to manually cover all
                 | three ways how the toggleFullScreen can occur:
                 |      Via menu buttons.
                 |      Via escape key when codemirror is focused.
                 |      Via escape key when codemirror is not focused.
                 */

                function handleFullscreenChange() {
                    toggleHeaders();

                    if (easyMDE.isFullscreenActive() === true) {
                        registerModifiedEscHandlers();
                    } else {
                        unregisterModifiedEscHandlers();
                    }
                }

                function toggleHeaders() {
                    $("[data-lfl-page-role='navigation-top']").toggle();
                    $("[data-lfl-page-role='main-header']").toggle();
                    // Only present in admin, but trying to hide it in user should cause no issues.
                    $("[data-lfl-page-role='navigation-sidebar']").toggle();
                }

                function registerModifiedEscHandlers() {
                    cmKeyMap.Esc = modifiedEscKeymap;
                    cm.setOption("extraKeys", cmKeyMap);
                    document.addEventListener("keydown", handleDocumentEsc);
                }

                function unregisterModifiedEscHandlers() {
                    cmKeyMap.Esc = originalEscKeymap;
                    cm.setOption("extraKeys", cmKeyMap);
                    document.removeEventListener("keydown", handleDocumentEsc);
                }

                /**
                 * Handle the toggle via escape key when codemirror is focused
                 * @param cmEditor
                 */
                var modifiedEscKeymap = function (cmEditor) {
                    originalEscKeymap(cmEditor);
                    handleFullscreenChange();
                };

                /**
                 * Handle the toggle via escape key when codemirror is not focused
                 * @param e
                 */
                function handleDocumentEsc(e) {
                    // The esc key
                    if (e.keyCode == 27) {
                        // This is only registered when the editor is/was full screen - no need to check for
                        // getOption("fullScreen").
                        handleFullscreenChange();
                    }
                }

                /*
                 |----------------------------------------------------------------------------------------
                 | Editor enable/disable
                 |-----------------------
                 | */

                /**
                 *
                 * @param {boolean} enabled Whether enabled or disabled.
                 */
                function storeEditorEnabledSetting(enabled) {
                    $.ajax({
                        url: parameters.storeEditorEnabledUrl,
                        type: "patch",
                        data: {
                            enabled: enabled
                        },
                        error: function (data) {
                            console.error("Unable to store editor enabled setting's state. Received data:");
                            console.error(data);
                        }
                    });
                }


                /*
                 |-------------------------------------------------------------------------------------------------------
                 | First initialization
                 |-------------------------------------------------------------------------------------------------------
                 */

                init();
            };
        }(Forms.Inputs, jQuery));
    }(Lfl.Forms, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));

